var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 17,
    viewBox: "0 0 39 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99981 1C5.79272 1.00896 6.5507 1.33492 7.11144 1.90809C7.67219 2.48127 7.99114 3.2561 8 4.06669C8 5.79973 6.56533 7 5.00019 7C4.20727 6.99104 3.4493 6.66508 2.88856 6.09191C2.32781 5.51873 2.00886 4.7439 2 3.93331C2 2.20008 3.43467 1 4.99981 1Z",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13C1 11.6739 1.52678 10.4021 2.46447 9.46447C3.40215 8.52678 4.67392 8 6 8C7.32608 8 8.59785 8.52678 9.53553 9.46447C10.4732 10.4021 11 11.6739 11 13",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 1C16.7927 1.00896 17.5507 1.33492 18.1114 1.90809C18.6722 2.48127 18.9911 3.2561 19 4.06669C19 5.79973 17.5653 7 16.0002 7C15.2073 6.99104 14.4493 6.66508 13.8886 6.09191C13.3278 5.51873 13.0089 4.7439 13 3.93331C13 2.20008 14.4347 1 15.9998 1Z",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9998 1C26.7927 1.00896 27.5507 1.33492 28.1114 1.90809C28.6722 2.48127 28.9911 3.2561 29 4.06669C29 5.79973 27.5653 7 26.0002 7C25.2073 6.99104 24.4493 6.66508 23.8886 6.09191C23.3278 5.51873 23.0089 4.7439 23 3.93331C23 2.20008 24.4347 1 25.9998 1Z",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13C12 11.6739 12.4741 10.4021 13.318 9.46447C14.1619 8.52678 15.3065 8 16.5 8C17.6935 8 18.8381 8.52678 19.682 9.46447C20.5259 10.4021 21 11.6739 21 13",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13C21 11.6739 21.5268 10.4021 22.4645 9.46447C23.4021 8.52678 24.6739 8 26 8C27.3261 8 28.5979 8.52678 29.5355 9.46447C30.4732 10.4021 31 11.6739 31 13",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeMiterlimit: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.1de1c628385cd8e77c67c8e167b17a12.svg";
export { ForwardRef as ReactComponent };